<template>
  <v-app>
    <AgentHeader v-if="!isLogin" @toggle-drawer="toggleDrawer" />

    <v-navigation-drawer app v-model="isOpen">
      <AgentSidebar />
    </v-navigation-drawer>
    <v-main>
      <router-view v-if="isConnected" :walletConnect="walletConnect" />
    </v-main>
    <AgentFooter v-if="!isLogin" />
  </v-app>
</template>

<script setup>
import { ref, getCurrentInstance, watch, onMounted } from 'vue';
import WalletConnect from '@/utils/walletConnect';
import AgentHeader from '@/components/Agent/AgentHeader.vue';
import AgentSidebar from '@/components/Agent/AgentSidebar.vue';
import AgentFooter from '@/components/Agent/AgentFooter.vue';
import { useRouter } from 'vue-router';
const { proxy } = getCurrentInstance();
const isOpen = ref(true);
const router = useRouter();
const loading = ref(false);
const isConnected = ref(false);
const setLoading = (value) => {
  loading.value = value;
  if(value){
    proxy.$toast.showMarkLoading();
  }else{
    proxy.$toast.hideMarkLoading();
  }
}
const isLogin = ref(false);

watch(() => router.currentRoute.value.name, (newName, oldName) => {
  console.log(newName, "newName", oldName, "oldName");
  if(newName === 'agent-login'){
    isLogin.value = true;
    isOpen.value = false;
  } else {
    isLogin.value = false;
    isOpen.value = true;  
  }
});
onMounted(() => {
  console.log(router, router.currentRoute.value.name, "router mounted")
  if(router.currentRoute.value.name === 'agent-login'){
    isLogin.value = true;
    isOpen.value = false;
  } else {
    isLogin.value = false;
    isOpen.value = true;
  }
})
const walletConnect = new WalletConnect(router, setLoading);

proxy.$eventBus.on('walletConnectInitialized', ()=> {
  isConnected.value = true;
});
function toggleDrawer() {
  isOpen.value = !isOpen.value;
}

</script>

<style scoped>
#app {
    margin: 0 auto;
    margin-top: 0!important;
}
.v-application {
  background-color: #e2e2f4; /* 设置整体背景颜色 */
}

.v-app-bar {
  box-shadow: none; /* 移除阴影 */
}


.v-card {
  background-color: #3e3e4e; /* 设置卡片背景颜色 */
  color: #fff; /* 设置卡片文字颜色 */
}
</style>